module.exports = __webpack_public_path__ + "media/images/aloe/illustrations/payment-32d5f278d351c2535b2f7bcde7e36e16.svg";